import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { featureFlagApi } from '../../services/featureFlagApi';

interface FeatureFlagsState {
  flags: Record<string, boolean>;
  loaded: boolean;
}

const initialState: FeatureFlagsState = {
  flags: {},
  loaded: false,
};

export const fetchFeatureFlags = createAsyncThunk(
  'featureFlags/fetch',
  async () => {
    const response = await featureFlagApi.getFlags();
    return response.data;
  }
);

const featureFlagsSlice = createSlice({
  name: 'featureFlags',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchFeatureFlags.fulfilled, (state, action) => {
      state.flags = action.payload;
      state.loaded = true;
    });
    builder.addCase(fetchFeatureFlags.rejected, (state) => {
      state.loaded = true;
    });
  },
});

export default featureFlagsSlice.reducer;
